import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-maintenance',
  templateUrl: './page-maintenance.component.html',
  styleUrls: ['./page-maintenance.component.scss']
})
export class PageMaintenanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
